import types from './types';

const fetchObservations = (observations, metadata, start, end) => {
  return {
    type: types.FETCH_OBSERVATIONS,
    payload: {
      observations,
      metadata,
      start,
      end,
    }
  };
};

const fetchObservationsError = (err) => {
  return {
    type: types.FETCH_OBSERVATIONS_ERROR,
    payload: err,
  }
};

const clearObservations = () => {
  return {
    type: types.FETCH_OBSERVATIONS_CLEAR,
  }
};

export default {
  fetchObservations,
  fetchObservationsError,
  clearObservations,
};



// WEBPACK FOOTER //
// ./src/redux/observations/actions.js